import { HealthcareFacilityLocationSpecialty } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { createTranslatedText, ValidationRules } from '@dreryk/react-common';

import { ReferralToHospitalFormBean } from '../ReferralToHospitalForm.types';

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const psychiatricHospitalWardCodes = [4700, 4701] as const;

export const isHealthcareFacilityLocationSpecialtyPsychiatric = (
   healthcareFacilityLocationSpecialty: HealthcareFacilityLocationSpecialty
): boolean => {
   return psychiatricHospitalWardCodes.some(
      (code) => code.toString() === healthcareFacilityLocationSpecialty.code.toString()
   );
};

export const validationRules: ValidationRules<ReferralToHospitalFormBean> = {
   required: true,
   validate: (value) => {
      const currentHealthcareFacilityLocationSpecialty = value as HealthcareFacilityLocationSpecialty | null;
      if (
         currentHealthcareFacilityLocationSpecialty &&
         isHealthcareFacilityLocationSpecialtyPsychiatric(currentHealthcareFacilityLocationSpecialty)
      ) {
         return createTranslatedText('');
      }
      return undefined;
   },
};
